import { useState } from 'react';
import DataTableNativeML from '@/components/DataTableNativeML';
import DeleteForeverOutlinedIcon from '@material-ui/icons/DeleteForeverOutlined';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import SvgIconML from '@/components/SvgIconML/SvgIconML';
import { useTheme } from '@emotion/react';
import { IconButton, Button } from '@material-ui/core';
import PropTypes from 'prop-types';
import ResultListStyled from './ResultListStyled';
import { useIntl } from 'umi';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import { history, useLocation } from 'umi';
import DialogDataML from '@/components/DialogDataML/DialogDataML';
import { useDispatch, useSelector } from 'dva';
import ButtonTip from '@/components/buttonTip/ButtonTip';
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      className="tab-content"
      {...other}
    >
      {value === index && (
        <Box style={{ overflowX: 'hidden' }} className="content-wrapper">
          {children}
        </Box>
      )}
    </Box>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const ResultList = (props) => {
  //关于测试
  const intl = useIntl();
  const { formatMessage } = intl;
  const dispatch = useDispatch();
  const theme = useTheme();
  const location = useLocation();

  const { query, pathname } = location;
  //是否是微信小程序订阅页面
  const isWmpPage = pathname.includes('/miniapps/template_list');
  const { pageNum, pageSize, title, type, appId } = query;
  const { pageData, tab } = props;

  const { handlePageChange } = props;
  //拿取数据
  const { data: templateList, total: templateTotal } =
    useSelector((state) => state.templateList?.wechatTemplateList) || {};
  const { data: templateMessageList, total: templateMessageTotal } =
    useSelector((state) => state.templateList?.wechatTemplateMessageList) || {};
  const loadingEffect = useSelector((state) => state.loading);
  const templateListLoading =
    loadingEffect.effects['templateList/getWechatTemplateList'];
  const templateMessageListLoading =
    loadingEffect.effects['templateList/getWechatTemplateMessageList'];
  const [openAddDialog, setOpenAddDialog] = useState(false);
  //换页
  const changePage = (obj) => {
    handlePageChange(obj);
  };
  const templateColumns = [
    {
      title: formatMessage({ id: 'wechat.official.c01.lbl02' }),
      align: 'left',
      id: 'templateId',
      key: 'templateId',
      width: '200',
    },
    {
      align: 'left',
      title: formatMessage({ id: 'wechat.official.c01.lbl03' }),
      id: 'title',
      event: {
        // onClick: (value, row) => handleMemberDetail(row),
      },
      // tdCellStyle: { color: 'rgb(21,101,192)', cursor: 'pointer' },
      // width: '200',
    },
    {
      title: formatMessage({ id: 'wechat.official.c01.lbl04' }),
      align: 'center',
      id: 'tempMsgCount',
      key: 'tempMsgCount',
      // width: 120,
    },
    {
      title: formatMessage({ id: 'wechat.official.c01.lbl05' }),
      align: 'center',
      id: 'mobile',
      key: 'mobile',
      // width: 140,
      render: (rowData) => {
        return (
          <div align="center" className="handle_btn">
            <ButtonTip title={formatMessage({ id: 'comm.action.btn.02' })}>
              <IconButton
                data-log={JSON.stringify({
                  oid: 'btn_wechat_account_template_message_template_list_create',
                  events: ['_ev', '_ec'],
                  params: {
                    initUrl: window.location.origin + window.location.pathname,
                  },
                })}
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                onClick={() => {
                  if (rowData.tempMsgCount > 0) {
                    setOpenAddDialog(true);
                    return;
                  }
                  history.push({
                    pathname: isWmpPage
                      ? '/miniapps/template_list/addWmpTemplate'
                      : '/system/wechat/addTemplate',
                    query: {
                      opt: 'add',
                      isWmpPage,
                      ...rowData,
                      id: String(rowData?.id),
                      sourceOid:
                        'btn_wechat_account_template_message_template_list_create',
                    },
                  });
                }}
              >
                <AddCircleOutlineIcon
                  size={24}
                  fill={theme.palette.primary.main}
                />
              </IconButton>
            </ButtonTip>
          </div>
        );
      },
    },
  ];
  const templateMessageColumns = [
    {
      align: 'center',
      title: 'ID',
      id: 'id',
      width: 80,
    },
    {
      title: isWmpPage
        ? '订阅消息名称'
        : formatMessage({ id: 'wechat.official.c02.lbl01' }),
      align: 'left',
      id: 'title',
      key: 'title',
    },
    {
      align: 'left',
      title: formatMessage({ id: 'wechat.official.c02.lbl02' }),
      id: 'templateTitle',
      key: 'templateTitle',
      event: {
        // onClick: (value, row) => handleMemberDetail(row),
      },
      // tdCellStyle: { color: 'rgb(21,101,192)', cursor: 'pointer' },
      // width: '200',
    },
    {
      title: formatMessage({ id: 'wechat.official.c02.lbl04' }),
      align: 'center',
      id: 'createBy',
      key: 'createBy',
      // width: 120,
    },
    {
      title: formatMessage({ id: 'wechat.official.c02.lbl05' }),
      align: 'center',
      id: 'createDate',
      key: 'createDate',
      // width: 120,
    },
    {
      title: formatMessage({ id: 'wechat.official.c02.lbl06' }),
      align: 'center',
      id: 'mobile',
      key: 'mobile',
      // width: 140,
      render: (rowData) => {
        return (
          <div align="center" className="handle_btn">
            <ButtonTip title={formatMessage({ id: 'comm.action.btn.03' })}>
              <IconButton
                data-log={JSON.stringify({
                  oid: 'btn_wechat_account_template_message_list_edit',
                  events: ['_ev', '_ec'],
                  params: {
                    initUrl: window.location.origin + window.location.pathname,
                  },
                })}
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                onClick={() => {
                  history.push({
                    pathname: isWmpPage
                      ? '/miniapps/template_list/editWmpTemplate'
                      : '/system/wechat/editTemplate',
                    query: {
                      opt: 'edit',
                      isWmpPage,
                      ...rowData,
                      id: String(rowData?.id),
                      sourceOid:
                        'btn_wechat_account_template_message_list_edit',
                    },
                  });
                }}
              >
                <SvgIconML
                  name="edit"
                  size={24}
                  fill={theme.palette.primary.main}
                  className="preview"
                />
                {/* <img src={editImg} alt="" /> */}
              </IconButton>
            </ButtonTip>
            <ButtonTip title={formatMessage({ id: 'comm.action.btn.04' })}>
              <IconButton
                data-log={JSON.stringify({
                  oid: 'btn_wechat_account_template_message_list_delete',
                  events: ['_ev', '_ec'],
                  params: {
                    initUrl: window.location.origin + window.location.pathname,
                  },
                })}
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                onClick={() => {
                  setOPenDialog(true);
                  setDialogContent({
                    content: formatMessage({ id: 'wechat.official.d01.txt01' }),
                    id: rowData.id,
                  });
                }}
              >
                <DeleteForeverOutlinedIcon
                  size={24}
                  fill={theme.palette.primary.main}
                />
              </IconButton>
            </ButtonTip>
            {/* <IconButton
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              // color="inherit"
              // className=""
            >
              <SvgIconML
                name="edit"
                size={24}
                fill="#1B60AD"
                // className={canPause && 'canClick'}
              />
            </IconButton> */}
          </div>
        );
      },
    },
  ];
  //删除弹出确认框
  const [openDialog, setOPenDialog] = useState(false);
  //内容和id
  const [dialogContent, setDialogContent] = useState();
  //取消
  const handleCloseDialog = () => {
    setOPenDialog(false);
  };
  const handleConfirm = () => {
    dispatch({
      type: 'templateList/deleteTemplateMessage',
      payload: {
        values: {
          id: dialogContent.id,
          isWmpPage,
        },
      },
      callback: (res) => {
        if (res.code === 0) {
          dispatch({
            type: 'templateList/getWechatTemplateMessageList',
            payload: {
              values: {
                pageNum,
                pageSize,
                appId,
                title,
                type,
                isWmpPage,
              },
            },
          });
        }
      },
    });
    setOPenDialog(false);
  };

  const templateContent = (
    <Box>
      <DataTableNativeML
        loading={templateListLoading}
        columns={templateColumns}
        changePage={changePage}
        page={pageData}
        data={templateList}
        devicesMinWidth={1640}
        total={templateTotal}
        paging={true}
        columnKey="id"
      ></DataTableNativeML>
    </Box>
  );
  const templateMessageContent = (
    <Box>
      <DataTableNativeML
        loading={templateMessageListLoading}
        columns={templateMessageColumns}
        changePage={changePage}
        devicesMinWidth={1640}
        page={pageData}
        data={templateMessageList}
        total={templateMessageTotal}
        paging={true}
        columnKey="id"
      ></DataTableNativeML>
    </Box>
  );
  const tabList = [
    {
      key: '1',
      name: formatMessage({ id: 'wechat.official.c01.lbl01' }),
      child: templateContent,
    },
    {
      key: '2',
      name: isWmpPage
        ? '订阅消息'
        : formatMessage({ id: 'wechat.official.n03.lbl02' }),
      child: templateMessageContent,
    },
  ];
  // console.log('cpList', cpList);
  // const [pageData, setPageData] = useState({
  //   pageSize: 10,
  //   pageNum: 1,
  // });

  //切换tab
  const handleChangeTab = (event, newValue) => {
    history.replace({
      pathname,
      query: {
        ...query,
        title: '',
        type: '',
        pageNum: 1,
        pageSize: 10,
        tab: (newValue + 1).toString(),
      },
    });
  };

  return (
    <ResultListStyled theme={theme}>
      <Box
        className="second-wrapper"
        // sx={{ borderBottom: 1, borderColor: 'divider' }}
      >
        <Tabs value={Number(tab) - 1} onChange={handleChangeTab}>
          {tabList.map((item, index) => (
            <Tab key={item.key} label={item.name} {...a11yProps(index)} />
          ))}
        </Tabs>
        {tabList.map((i, index) => (
          <TabPanel value={Number(tab) - 1} index={index} key={i.key}>
            {i.child}
          </TabPanel>
        ))}
      </Box>
      <DialogDataML
        open={openDialog}
        title={formatMessage({ id: 'comm.action.btn.04' })}
        content={dialogContent?.content}
        handleClose={handleCloseDialog}
        handleConfirm={handleConfirm}
      ></DialogDataML>
      <DialogDataML
        open={openAddDialog}
        title="提醒"
        content="每个模板下只能创建一条订阅消息，当前模板现不支持创建"
        button={{
          isShow: true,
          buttonNode: (
            <Button
              sx={{ width: '62px !important' }}
              onClick={() => setOpenAddDialog(false)}
            >
              知道了
            </Button>
          ),
        }}
      ></DialogDataML>
    </ResultListStyled>
  );
};
export default ResultList;
